module.exports = __webpack_public_path__ + "img/purple.bf677d42.jpg";